<template>
  <div>
    <nav
      class="navbar is-spaced is-primary"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="container">
        <div class="navbar-brand">
          <div>
            <img src="@/assets/logo.png" alt="Logo" width="193" height="47" />
          </div>
        </div>
        <div class="navbar-menu">
          <div class="navbar-start">
            <a href="/wls/" class="navbar-item is-size-4"
              ><strong>Weißer Leihschein</strong></a
            >
          </div>
          <div class="navbar-end">
            <router-link
              v-if="loggedIn"
              to="/logout"
              class="navbar-item button is-primary"
            >
              <b-icon icon="logout"></b-icon>
              <span>
                Abmelden
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <section id="app" class="section container">
      <template v-if="$route.matched.length">
        <router-view></router-view>
      </template>
      <template v-else>
        <p>You are logged {{ loggedIn ? "in" : "out" }}</p>
      </template>
    </section>
  </div>
</template>

<script>
import auth from "./auth";

export default {
  data() {
    return {
      loggedIn: auth.loggedIn()
    };
  },
  created() {
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
    };
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #557fbb;
$primary-invert: #ffffff;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);

$navbar-item-color: $primary-invert;

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
